module.exports = __webpack_public_path__ + "c75b92caa3fbf4b831c240a7531ef685.svg";